;(function () {
  'use strict';

  function resizeSquare() {
    var CONTAINER_SELECTOR = '.js-img-square-resize-container';
    var RESIZE_SELECTOR = '.js-img-square-resize';

    var $container = $(CONTAINER_SELECTOR);
    var $selector = $(RESIZE_SELECTOR);

    $container.find($selector).each(function () {
      var width = $(this).width();
      $(this).height(width);
    })
  };

  $(function () {
    resizeSquare();
  });
}.call(this));
